const styles = (theme) => ({
  dialog: {
    width: "32%",
    maxWidth: 490,
    minHeight: 362,
    flex: 1,
    backgroundColor: theme.ModalBGColor,
  },
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 0 0 20",
    borderBottom: `1px solid ${theme.scrollThumbColor}`,
  },
  dialogTitleText: {
    flexDirection: "column",
    fontSize: theme.headerTextFontSize,
    fontWeight: "600",
    lineHeight: "20px",
    color: theme.palette.primary.main,
    display: "flex",
  },
  dialogContent: {
    padding: "12 20 20 20",
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
  },
  closeButton: {
    padding: 2,
    color: theme.iconColor,
    textAlignLast: "right",
  },
  notesLabel: {
    fontSize: theme.dispatchCardTextFontSize,
    fontWeight: 500,
    lineHeight: "16px",
    color: theme.dispatchPanelLabelValueColor,
  },
  fullWidth: {
    marginTop: 6,
    width: "100%",
    flex: 1,
  },
  root: {
    marginTop: 0,
    "& $notchedOutline": {
      borderColor: theme.gridIconBorderColor,
    },
  },
  inputField: {
    fontSize: theme.textFontSize,
    color: theme.dispatchPanelLabelValueColor,
    height: "initial",
    resize: "auto",
  },
  notchedOutline: {
    borderColor: theme.gridIconBorderColor,
  },
  inputLabelRoot: {
    color: theme.dispatchPanelHeaderColor,
    fontSize: theme.textFontSize,
  },
});

export default styles;
